import { createSlice } from '@reduxjs/toolkit';
import { GetStagedShipmentState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { getStagedShipmentThunk } from './thunks';

// Initial State
const initialState: GetStagedShipmentState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const getStagedShipmentSlice = createSlice({
  name: 'getStagedShipment',
  initialState,
  reducers: {
    setValues: (state, action) => ({
      ...state,
      values: action.payload,
    }),
    resetShipmentList: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getStagedShipmentThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(getStagedShipmentThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(getStagedShipmentThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { resetShipmentList, setValues } = getStagedShipmentSlice.actions;
export * from './thunks';
export * from './selectors';
export default getStagedShipmentSlice.reducer;
